(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityRecoveryMetricsController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        init();

        // Convert hours/minutes inputs back to total minutes for Expert MTPD
        $scope.onMtpdExpertChange = function () {
            var hours = parseInt($scope.ctrlCtxt.expertHours, 10) || 0;
            var minutes = parseInt($scope.ctrlCtxt.expertMinutes, 10) || 0;
            var total = (hours * 60) + minutes;
            $scope.boxModel.MtpdExpertValue = total > 0 ? total : null;
        };

        // Convert hours/minutes inputs back to total minutes for Calculated MTPD
        $scope.onMtpdCalculatedChange = function () {
            var hours = parseInt($scope.ctrlCtxt.calculatedHours, 10) || 0;
            var minutes = parseInt($scope.ctrlCtxt.calculatedMinutes, 10) || 0;
            var total = (hours * 60) + minutes;
            $scope.boxModel.MtpdCalculatedValue = total > 0 ? total : null;
        };

        // Format minutes to display string (e.g. 130 → "2h 10m")
        $scope.formatMinutes = function (totalMinutes) {
            if (totalMinutes == null) return '';
            var h = Math.floor(totalMinutes / 60);
            var m = totalMinutes % 60;
            if (h > 0 && m > 0) return h + 'h ' + m + 'm';
            if (h > 0) return h + 'h';
            return m + 'm';
        };

        // Save Changes — delegates to parent scope via onBoxModelSaveChanges callback
        $scope.saveChanges = function (form) {
            if (form.$invalid) return;
            $scope.onBoxModelSaveChanges();
        };

        // Cancel — delegates to parent scope close callback
        $scope.onModalClose = function () {
            $scope.close();
        };

        function init() {
            if ($scope.boxModel.MtpdExpertValue != null) {
                $scope.ctrlCtxt.expertHours = Math.floor($scope.boxModel.MtpdExpertValue / 60);
                $scope.ctrlCtxt.expertMinutes = $scope.boxModel.MtpdExpertValue % 60;
            } else {
                $scope.ctrlCtxt.expertHours = null;
                $scope.ctrlCtxt.expertMinutes = null;
            }

            if ($scope.boxModel.MtpdCalculatedValue != null) {
                $scope.ctrlCtxt.calculatedHours = Math.floor($scope.boxModel.MtpdCalculatedValue / 60);
                $scope.ctrlCtxt.calculatedMinutes = $scope.boxModel.MtpdCalculatedValue % 60;
            } else {
                $scope.ctrlCtxt.calculatedHours = null;
                $scope.ctrlCtxt.calculatedMinutes = null;
            }
        }
    }
})();
